import { Controller } from "stimulus";
import { M } from "@materializecss/materialize/dist/js/materialize";
import displayFlashMessage from "../../functions/displayFlashMessage.js";
import  DOMPurify  from "dompurify";

export default class extends Controller {
  static get targets() {
    return ["modal"];
  }

  connect() {
    M.Modal.init(this.modalTarget, this.modalAnimationOptions);

    if (this.open) {
      this.openModal();
    }
  }

  openModal(event) {
    if (event) {
      event.preventDefault();
    }

    this.materializeModal.open();
  }

  closeModal() {
    this.materializeModal.close();
  }

  async fetchNextModal(event) {
    if (event) {
      event.preventDefault();
    }

    const url = new URL(this.element.action);
    const formData = new FormData(this.element);

    new URLSearchParams(formData).forEach((value, key) => url.searchParams.set(key, value));

    const response = await fetch(url.toString());

    if (!response.ok) {
      // Render validation error messages from GET request
      const contentType = response.headers.get("content-type");

      if (contentType && contentType.indexOf("application/json") !== -1) {
        response.json().then(data => {
          data.messages.forEach(function (message) {
            displayFlashMessage(message);
          });
        });

        return;
      }
    }

    const html = await response.text();

    let nextModalContainer = document.createElement("div");
    nextModalContainer.className = "next-modal-container";
    nextModalContainer.innerHTML = DOMPurify.sanitize(html);

    this.element.insertAdjacentElement("afterend", nextModalContainer);

    this.closeModal();
  }

  _cleanup(el) {
    const dynamicContainer = el.closest(".next-modal-container");

    if (dynamicContainer) dynamicContainer.remove();
  }

  get open() {
    return this.modalTarget.dataset.open === "true";
  }

  get materializeModal() {
    return M.Modal.getInstance(this.modalTarget);
  }

  get modalAnimationOptions() {
    return {
      inDuration: 0,
      outDuration: 0,
      starting_top: "12%",
      ending_top: "18%",
      dismissible: false,
      onCloseEnd: (el) => {
        this._cleanup(el);
      }
    };
  }
}
